module.exports = __webpack_public_path__ + "img/black.7db56677.jpg";